import moment from 'moment';
import { DataGridLayout, Filters, FiltersLayout, List, ListHeader, ListPageLayout } from 'framework/list';
import useJournalEntryService, { CREATE_JOURNAL_ENTRY } from 'domain/finance/journalEntry/useJournalEntryService';
import CreateJournalEntryButton from 'domain/finance/journalEntry/shared/button/CreateJournalEntryButton';
import { DATE_FORMAT } from 'framework/utils';
import JournalEntryStaticFilters from 'domain/finance/journalEntry/shared/filter/JournalEntryStaticFilters';
import JournalEntryLink from 'domain/finance/journalEntry/shared/field/JournalEntryLink';
import ViewJournalEntryButton from 'domain/finance/journalEntry/shared/button/ViewJournalEntryButton';
import { DateField, TextField } from 'framework/ui/field';
import ListPageHeaderWrapper from '../../shared/ListPageHeaderWrapper';
import UploadJournalEntryButton from '../shared/button/UploadJournalEntryButton';
import { useJournalEntryUrl } from '../shared/useJournalEntryRouting';
import { EmployeeFilter, OfficeFilterById } from 'domain/shared/employee';
import DownloadJournalEntriesCsvReportButton from 'domain/finance/journalEntry/shared/button/DownloadJournalEntriesCsvReportButton';

const JournalEntryListPage = () => {
  const { search, getFilterValidationSchema } = useJournalEntryService();
  const { getUploadJournalEntryUrl } = useJournalEntryUrl();
  const currentMonthStart = moment().startOf('month').format(DATE_FORMAT.API_ONLY_DATE);
  const currentMonthEnd = moment().endOf('month').format(DATE_FORMAT.API_ONLY_DATE);

  const filters = (
    <FiltersLayout>
      <EmployeeFilter label="Posted By" source="postedBy" />
      <EmployeeFilter source="employeeAlias" label="Worker" />
      <OfficeFilterById source="offices" label="Office" />
    </FiltersLayout>
  );

  return (
    <List
      getDataMethod={search}
      defaultFilter={{
        period: {
          ge: currentMonthStart,
          le: currentMonthEnd,
        },
      }}
      uncontrolledFilters={['period']}
      shouldSaveUncontrolledFilters
    >
      <Filters getValidationSchema={getFilterValidationSchema}>
        <ListPageLayout
          header={
            <ListPageHeaderWrapper
              header={
                <JournalEntryStaticFilters
                  isInListHeaderWrapper
                  title={<ListHeader label="Journal Entries" />}
                  sx={{
                    '& > div:last-child': {
                      mt: 1.5,
                    },
                  }}
                />
              }
              actions={[
                <UploadJournalEntryButton url={getUploadJournalEntryUrl()} permissionToCheck={CREATE_JOURNAL_ENTRY} />,
                <DownloadJournalEntriesCsvReportButton />,
              ]}
            />
          }
          actions={[<CreateJournalEntryButton />]}
          filter={filters}
        >
          <DataGridLayout
            buttons={[<ViewJournalEntryButton source="id" />]}
            sxTableWrapper={{
              '& table.MuiTable-root': {
                minWidth: '1080px',
              },
            }}
            rowProps={(data: any) =>
              data.transfers[0]?.isStorno
                ? {
                    sx: {
                      backgroundColor: 'common.deletedTableRow',
                      '&:hover, &:hover > td, &:hover > th': {
                        backgroundColor: 'common.tableRowHover',
                      },
                    },
                  }
                : {}
            }
          >
            <JournalEntryLink source="id" label="Number" width="25%" />
            <DateField source="asDateOf" label="Date" width="25%" />
            <TextField source="description" width="50%" />
          </DataGridLayout>
        </ListPageLayout>
      </Filters>
    </List>
  );
};

export default JournalEntryListPage;
